// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vNnCtTlxptix0A7q6VOuI {\n    display: inline;\n}\n", "",{"version":3,"sources":["webpack://./src/views/components/common/EditableTitle.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":[":local(.inlineForm) {\n    display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineForm": "vNnCtTlxptix0A7q6VOuI"
};
export default ___CSS_LOADER_EXPORT___;
